      import React,{useContext, useState} from 'react'
      import {Link, useNavigate} from 'react-router-dom'
      
      import { ToastContainer, toast } from 'react-toastify';
      import 'react-toastify/dist/ReactToastify.css';
      
      import {UserContex} from '../App'
      import Header from '../components/Header';
      
      
      const FundCompletionCard = ()=>{
        
      const navigate = useNavigate()
          return(
      
      
      <>
      <>
      <Header></Header>
        {/* component */}
      
        <p class="mb-0 text-center text-3xl font-extrabold text-purple-500 ">
                      Thank You So Much!
                  </p>
      <div   className="bg-gray-50 flex items-center justify-center px-5 py-5">
        <div  className="grid relative grid-cols-1 gap-6 md:grid-cols-1 xl:grid-cols-1">

        <div class="flex items-center justify-between w-full p-4 bg-white shadow-lg rounded-2xl mb-5">
    <div class="w-2/6">
        <img src="/logo.png" alt="person" class="w-12 h-12 rounded-full"/>
    </div>
    <div class="w-3/6">
        <p class="text-sm text-gray-500">
            We will send the links to movie and documentary at the end of the campaign on  May 5th 2025.
            <br></br>
            Thank you for your contribution.
            
        </p>
    </div>
    <div class="w-1/6 text-right">
        <svg width="20" height="20" fill="currentColor" viewBox="0 0 1792 1792" class="w-6 h-6 text-indigo-500" xmlns="http://www.w3.org/2000/svg">
            <path d="M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z">
            </path>
        </svg>
    </div>
</div>




      


          
        </div>
      </div>
             
      
      </>
      
      {/* <div class="flex flex-wrap w-full">
          <div class="flex flex-col w-full md:w-1/2">
             
              <div class="flex flex-col justify-center px-8 pt-8 my-auto md:justify-start md:pt-0 md:px-24 lg:px-32">
                 
              
      <form class="flex w-full max-w-sm space-x-3">
          <div class="w-full max-w-2xl px-5 py-10 m-auto mt-10 bg-white rounded-lg shadow dark:bg-gray-800">
              <div class="mb-6 text-3xl font-light text-center text-gray-800 dark:text-white">
                  Contact us !
              </div>
              <div class="grid max-w-xl grid-cols-2 gap-4 m-auto">
                  <div class="col-span-2 lg:col-span-1">
                      <div class=" relative ">
                          <input type="text" id="contact-form-name" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Name"/>
                          </div>
                      </div>
                      <div class="col-span-2 lg:col-span-1">
                          <div class=" relative ">
                              <input type="text" id="contact-form-email" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="email"/>
                              </div>
                          </div>
                          <div class="col-span-2">
                              <label class="text-gray-700" for="name">
                                  <textarea class="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" id="comment" placeholder="Enter your comment" name="comment" rows="5" cols="40">
                                  </textarea>
                              </label>
                          </div>
                          <div class="col-span-2 text-right">
                              <button type="submit" class="py-2 px-4  bg-blue-500 hover:bg-blue-600 focus:ring-blue-500 focus:ring-offset-indigo-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                                  Send
                              </button>
                          </div>
                      </div>
                  </div>
              </form>
      
                        
                      </div>
                  </div>
                  <div class="w-1/2 shadow-2xl">
                      <img class=" object-fit w-full h-screen " src="/contact.jpeg"/>
                  </div>
              </div> */}
      
     
      </>
        
      
      
          );
      }
      
      export default FundCompletionCard;